import React from "react";
import PropTypes from "prop-types";
import { Container, Typography } from "@mui/material";
import { isEmpty } from "ramda";

import Placeholder from "components/Placeholder";
import StarringYouClipsCarousel from "components/StarringYouClipsCarousel";

import useStyles from "./useStyles";

const FeaturedClips = ({ items, loading = false, showVideo = true, titleVariant = "h1", title }) => {
  const classes = useStyles();

  const renderTitle = () => {
    if (loading)
      return (
        <Typography variant={titleVariant}>
          <Placeholder variant="text" height={60} />
        </Typography>
      );

    if (isEmpty(items)) return null;

    return (
      <Typography variant={titleVariant} className={classes.title}>
        {title}
      </Typography>
    );
  };

  return (
    <div className={classes.root}>
      <Container>{renderTitle()}</Container>
      <StarringYouClipsCarousel items={items} loading={loading} showVideo={showVideo} />
    </div>
  );
};

FeaturedClips.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      type: PropTypes.string,
      attributes: PropTypes.shape({}),
    }).isRequired,
  ),
  loading: PropTypes.bool,
  showVideo: PropTypes.bool,
  titleVariant: PropTypes.string,
  title: PropTypes.string,
};

export default FeaturedClips;
